export const allData = {
    "ai-agents-guide": [
      {
        title: "Flowcess",
        link: "what-is-flowcess",
      },
      {
        title: "Process",
        link: "what-is-process",
      },
      // {
      //   title: "Firewall",
      //   link: "what-is-firewall",
      // },
      {
        title: "AI Agent",
        link: "what-is-ai-agent",
      },
      {
        title: "AI Studio",
        link: "what-is-ai-studio",
      },
      // {
      //   title: "AI Coworker",
      //   link: "what-is-ai-coworker",
      // },
    ],
    "ai-agents-permissions": [
        {
            title: "Workspace Roles & Permissions",
            link: "roles-workspace",
        },
        {
            title: "Project Roles & Permissions",
            link: "roles-projects",
        },
        {
            title: "CRM Roles & Permissions",
            link: "roles-crm",
        }
    ],
    "ai-agents-tools": [
      {
          title: "Intent Collection",
          link: "intent-collection",
      },
      {
        title: "Entity",
        link:"entity"
      },
      {
        title: "Knowledge Base",
        link:"knowledge-base"

      },
      {
        title: "Prompt",
        link:"what-is-prompt"
      },
      {
        title: "Knowledge Engine",
        link:"knowledge-engine"
      },
      {
        title: "Flowcess",
        link:"flowcess"
      },
      {
        title: "Secrets",
        link:"secrets"
      },
      {
        title: "API",
        link:"api"
      },
      {
        title: "Function",
        link:"function"
      },
  ],
    "ai-agents-how-to-integrate-app": [
      {
        title: "What is App Directory?",
        link: "app-directory",
    },
    {
        title: "How to Create Anydone App?",
        link: "how-to-create-anydone-app",
    },
    {
        title: "AIChat",
        link: "aichat",
    },
    {
        title: "How to Integrate Mail Service?",
        link: "how-to-integrate-mail-service",
    },
    {
        title: "How to integrate Slack?",
        link: "how-to-integrate-slack",
    },
    {
        title: "How to Create a Live Capture App?",
        link: "how-to-create-a-live-capture-app",
    },
    {
        title: "How to Integrate Messenger?",
        link: "how-to-integrate-messenger",
    },
    {
        title: "How to Integrate GitHub",
        link: "how-to-integrate-github",
    },
    {
        title: "How to Integrate WhatsApp?",
        link: "how-to-integrate-whatsapp",
    }
    ],
    "ai-agent": [
        {
          title: "Ticket Create",
          link: "how-to-build-auto-tickets-create",
        },
        {
          title: "Text to Speech",
          link:"how-to-create-text-to-speech"
        },
        {
          title: "Speech to Text",
          link:"how-to-create-speech-to-text"
        },
        {
          title: "OCR",
          link:"how-to-create-ocr"
        },
        {
          title: "Grammar Check",
          link:"how-to-create-grammar-check"
        },
        {
          title: "Translation",
          link:"how-to-create-translation"
        },
        {
          title: "Text Summarization",
          link:"how-to-create-text-summarization"
        },
        {
          title: "Object Detection",
          link:"how-to-create-object-detection"
        },
        {
          title: "Face Detection",
          link:"how-to-create-face-detection"
        },
        {
          title: "Face Recognition",
          link:"how-to-create-face-recognition"
        },
        {
          title: "Image comparison",
          link:"how-to-create-image-comparison"
        },
        {
          title: "Image generation",
          link:"how-to-create-image-generation"
        },
        {
          title:"Image Understanding",
          link:"how-to-create-image-understanding"
        },
        {
          title:"Text Generation",
          link:"how-to-create-text-generation"
        },
        {
          title:"Code Generation",
          link:"how-to-create-code-generation"
        },
        {
          title:"Input Block",
          link:"how-to-create-input-block"
        },
        {
          title:"Condition Blocks",
          link:"how-to-create-condition-block"
        },
        {
          title:"Find In Internet",
          link:"find-in-internet"
        },
        {
          title:"Web Scrapping",
          link:"web-scrapping"
        },
        {
          title:"Confirmation Block",
          link:"how-to-create-confirmation-block"
        },
        {
          title:"Send Reply",
          link:"how-to-send-reply"
        },
        {
          title:"Data Request",
          link:"how-to-request-data"
        },
        {
          title:"Authenticate Block",
          link:"how-to-create-authenticate-block"
        },
        {
          title:"Forward Block",
          link:"how-to-create-forward-block"
        },
        {
          title:"Template Block",
          link:"how-to-create-template-block"
        },
      ],
  };